import { configureStore } from '@reduxjs/toolkit';

import general from './general';
import registration from './registration';
import results from './results';
import scoring from './scoring';

export const store = configureStore({
  reducer: {
    scoring,
    results,
    general,
    registration,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
